import SearchOnboardingDialog from './onboarding-dialog';
import SearchBranch from './search-branch';
import SearchBrand from './search-brand';
import SearchItem from './search-item';

import { Card } from '@growdash/design-system/atoms';

import PageWithTitle from '@growdash/growintel/components/hocs/with-title';
import { useTabState } from '@growdash/growintel/hooks';

export default function SearchView() {
  const { activeSubTab } = useTabState('search');

  return (
    <>
      <SearchOnboardingDialog />
      <PageWithTitle title="Search">
        <Card>
          {(!activeSubTab || activeSubTab === 'brand') && <SearchBrand />}
          {activeSubTab === 'branch' && <SearchBranch />}
          {activeSubTab === 'item' && <SearchItem />}
        </Card>
      </PageWithTitle>
    </>
  );
}
